import { PAGEPATHS } from "components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useParams } from "react-router-dom" //
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import DataTableWithPopup from "components/longContentTable";

const MailServer = (props) => {
    document.title = "Mail Server";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [trustMailData, setTrustMailData] = useState({})

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Mail Server", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Mail Server", breadcrumbItems)
    })

    useEffect(() => {
        const getTrustMailData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_TRUST_MAIL_SCAN}/${scanId}`)
                const valid = Object.entries(data.data).reduce((a, v) => {
                    a.columns.push({
                        label: v[0],
                        field: v[0],
                        sort: 'asc',
                        width: 150
                    })
                    if (typeof v[1] === 'boolean' || v[1] === 0) {
                        a.rows[0][v[0]] = v[1].toString()
                    } else if (v[1] === null) {
                        a.rows[0][v[0]] = 'NaN'
                    } else {
                        a.rows[0][v[0]] = v[1]
                    }
                    return a
                }, { columns: [], rows: [{}] })
                setTrustMailData(valid)
            } catch (e) {
                console.error(e);
            }
        }
        getTrustMailData()
    }, [scanId])

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <TableHeader scanName={"Trust Mail"} scanId={scanId} />
                        <CardBody className="search-engine-table">
                            {trustMailData && trustMailData.rows && (
                                <DataTableWithPopup noBottomColumns thirdPartyData={trustMailData} />
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(MailServer)